import CurrencyFormatter from "currency-formatter";

export default function ArrayItem({ name, data, bold = false }) {
  return (
    <div className={`flex items-center mt-5 ${bold && "font-semibold"}`}>
      <div className={`flex items-center pt-5 ${bold && "mt-2 border-t"}`} style={{ minWidth: "12em" }}>
        {name}
      </div>
      {data?.map((obj) => (
        <div className={`flex pt-5 ${bold && "mt-2 border-t"}`} style={{ minWidth: "10em" }}>
          <div style={{ minWidth: obj?.disabled ? "4em" : "1.8em" }} />
          {
            obj?.value  < -0.0001   //to avoid -0.00000001 to look like ($0.00)
              ? "(" + CurrencyFormatter.format(-obj?.value, { code: "USD" }) + ")"
              : CurrencyFormatter.format(obj?.value + 0.0001, { code: "USD" })
          }
        </div>
      ))}
    </div>
  );
}
